import { ReactNode, useEffect } from 'react'
import { initialQueryState } from '_metronic/helpers'
import { ActiveFilter, ActiveFiltersBar, CheckBox, TableFilter, TableFilters } from 'app/components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Marcar todas como lidas"). */
  actions?: ReactNode
}

export const NotificacoesListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  // "Não lidas" vai como filtro próprio da URL (`lida=false`), não no `search`.
  useEffect(() => {
    updateState({
      ...initialQueryState,
      filters: filters.somenteNaoLidas
        ? [{ field: 'lida', operator: '=', value: false }]
        : undefined,
    })
  }, [filters.somenteNaoLidas, updateState])

  const activeFilters: ActiveFilter[] = filters.somenteNaoLidas
    ? [
        {
          key: 'somenteNaoLidas',
          label: 'Situação',
          value: 'Não lidas',
          onRemove: () => setFilter('somenteNaoLidas', undefined),
        },
      ]
    : []

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'notificação encontrada' : 'notificações encontradas'}`
          }
        />
      }
    >
      <TableFilter label='Situação'>
        <CheckBox
          id='somenteNaoLidas'
          checked={!!filters.somenteNaoLidas}
          label='Mostrar somente não lidas'
          onChange={() => setFilter('somenteNaoLidas', filters.somenteNaoLidas ? undefined : true)}
        />
      </TableFilter>
    </TableFilters>
  )
}
